import { Injectable, Inject } from '@angular/core';
import { WebStorageService, SESSION_STORAGE } from 'ngx-webstorage-service';
import { DetalleCaso, ModelCaso } from '../app/model/pld/detallecaso.model';

@Injectable({
	providedIn: 'root',
})
export class ComunicacionService {

	constructor(@Inject(SESSION_STORAGE) private storage: WebStorageService) {}

	setCaso(caso: DetalleCaso) {
		this.storage.set('caso', caso);
	}

	getCaso() {
		let result = this.storage.get('caso');
		return result;
	}

	setPersona(personaId: number) {
		this.storage.set('persona', personaId);
	}

	getPersona() {
		let result = this.storage.get('persona');
		return result;
	}

	setPersonaTipo(tipoPersona: number) {
		this.storage.set('personaTipo', tipoPersona);
	}

	getPersonaTipo() {
		let result = this.storage.get('personaTipo');
		return result;
	}

	setCnsHistorica(tipoPersona: number) {
		this.storage.set('cnsHistorica', tipoPersona);
	}

	getCnsHistorica() {
		let result = this.storage.get('cnsHistorica');
		return result;
	}

	setLenguaje(lang: string) {
		if (this.getLenguaje() !== null) {
			this.storage.remove('language');
		}
		this.storage.set('language', lang);
	}

	getLenguaje() {
		return this.storage.get('language');
	}

	setSujetoObligado(sujetoObligado) {
		this.storage.set('sujetoObligado', sujetoObligado);
	}

	getSujetoObligado() {
		return this.storage.get('sujetoObligado');
	}

	setParametrosMatriz(parametros) {
		try {
			parametros.primaria = parametros.primaria.toString().toLowerCase() == 'false' 
				? false : true;
			parametros.temprana = parametros.temprana.toString().toLowerCase() == 'no' 
				? false : true;
		} catch (error) {
		  //Se mantiene de momento sin el mensaje
		}
		this.storage.set('parametrosMatriz', parametros);
	}

	getParametrosMatriz() {
		return this.storage.get('parametrosMatriz');
	}

	setCasoTmp(caso: ModelCaso) {
		this.storage.set('casoTmp', caso);
	}

	getCasoTmp() {
		var dato = this.storage.get('casoTmp');
		return dato;
	}
	setTipoReporteId(tipoReporte: number) {
		this.storage.set('tipoReporteId', tipoReporte);
	}

	getTipoReporteId() {
		return this.storage.get('tipoReporteId');
	}
	setValidaFormularioCaso(valor: boolean) {
		this.storage.set('validaCasoForm', valor);
	}
	getValidaFormularioCaso() {
		return this.storage.get('validaCasoForm');
	}

	limpiarStorage(caso: boolean) {
		if (!caso) {
			if (this.getCaso() !== null) {
				this.storage.remove('caso');
			}
			if (this.getPersona() !== null) {
				this.storage.remove('persona');
			}
			if (this.getPersonaTipo() !== null) {
				this.storage.remove('personaTipo');
			}
		} else {
			if (this.getPersona() !== null) {
				this.storage.remove('persona');
			}
			if (this.getPersonaTipo() !== null) {
				this.storage.remove('personaTipo');
			}
			if (this.getSujetoObligado() !== null) {
				this.storage.remove('sujetoObligado');
			}
		}
	}
}
